import { useOutsideClick } from '../../../util/misc';

interface Option {
    value: string;
    name: string;
}

interface SelectProps {
    name: string;
    value: string;
    options: Option[];
    onChange: (v: string | null) => void;
}

export default function Select({ name, value, options, onChange }: SelectProps) {
    const { dropdownRef, isOpen, setIsOpen } = useOutsideClick();
    return (
        <div
            className="select-box selectable"
            style={{ zIndex: 9992 }}
            ref={dropdownRef}
            onClick={() => setIsOpen(!isOpen)}
        >
            <span className="select-box__cont countries">{value || name}</span>
            <ul className="select-box__dropdown" style={{ display: isOpen ? 'block' : 'none' }}>
                <li className={'scroll-content' + (value ? '' : ' active')}>
                    <span className="checkbox__txt" onClick={() => onChange(null)}>
                        Все
                    </span>
                </li>
                {isOpen &&
                    options.map((o, idx) => (
                        <li
                            key={idx}
                            className={'scroll-content' + (value !== o.value ? '' : ' active')}
                            onClick={() => onChange(o.value)}
                        >
                            <span className="checkbox__txt">{o.name}</span>
                        </li>
                    ))}
            </ul>
        </div>
    );
}
